$(document).ready(function(){

  // Product page redirects
  if (String(window.location.href).indexOf("/products/tikro-silko-pagalves-uzvalkalai") != -1 ){
    console.log('SHould be redirect');
    window.location = 'https://noreo.lt/products/noreo-naturalaus-silko-pagalves-uzvalkalas';
  }

  // Selecting by default first color, loading animations ant etc
   setTimeout(function(){
      var variant_id = String(window.location);
      variant_id = variant_id.split('?variant=');
      variant_id = variant_id[1];
      if (typeof(variant_id) != 'undefined'){
        variant_id = variant_id.substring(0, 14)
      var currentColor;
        console.log(variant_id, 'VARIANT ID');
      $('.Product_form_variant_checker__js').each(function(){
        if ($(this).attr('data-id') == variant_id){
          currentColor = $(this).attr('data-variant-color');
          // console.log($(this).attr('data-id'), variant_id, '  testing =========================');
        }
      });
        $('.'+currentColor+'_input_select__js').trigger('click');
        console.log(currentColor, 'CURRENT COLOR ===== ');
      }
      else{
        $('.First_variant_trigger').trigger('click');
      }
      // $('.First_variant_trigger').trigger('click');
      $('.Product_section_image_gallery').addClass('loaded');
      $('.Product_images_mob').addClass('loaded');
  },100);
  
  // Setting up random active users
  const min = 30;
  const max = 130;
  const active_users = Math.floor(Math.random() * (max - min + 1) + min);
  $('.Atc_active_users_js').text(active_users);

  $('.product-form__input.Size_selector input').click(function(){
    var data = $(this).attr('value');
    console.log(data);

    // Preselecting specific size
    if (String(data).indexOf('51x91') != -1){
      // console.log('special');
      if ( $('.product-form__input.Color_selector input[value="Svetlo siva"]').is(':checked') || $('.product-form__input.Color_selector input[value="Kremna"]').is(':checked')){

      }
      else{
        if (!$('.product-form__input.Color_selector input[value="Kremna"]').is(':checked')) {
            $('.product-form__input.Color_selector input[value="Kremna"]').trigger('click');
        }
      }
     
    }

  });

  // Variant selection catching, image gallery switching by variant
  $('.product-form__input.Color_selector input').click(function(){
      var data = $(this).attr('value');

      console.log(data);
      if (String(data).indexOf('Kremna') != -1 || String(data).indexOf('Svetlo siva') != -1){
        console.log('special');
        $('.product_variant_option__51x91-cm').show();
      }
      else{
        console.log($('.product-form__input.Size_selector input[data-value="51x91-cm"]').is(':checked')); 
        if ($('.product-form__input.Size_selector input[data-value="51x91-cm"]').is(':checked')){
          $('.product-form__input.Size_selector input[value="51x66 cm"]').trigger('click');
          
        }
        $('.product_variant_option__51x91-cm').hide();
      }
    
      $('.js.product-form__input.Color_selector').find('.form__label').text('Izberite svojo barvo: '+data);
      var data_handle = data.toLowerCase().replace(/ /g,'-').replace('š', 's').replace('š', 's').replace('ė', 'e').replace('ž', 'z').replace('ē', 'e').replace('ā', 'a').replace('ļ', 'l').replace('ū', 'u').replace('č', 'c').replace('č', 'c');
      $('.Product_main_image').hide();
      $('.Product_main_image').each(function(){
        var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
          if (current_color == data_handle ){
            console.log(current_color, data_handle);
              $(this).show();
          }
      });
    
    $('.product_main_images_slider').hide();
    $('.product_main_images_slider_nav').hide();
    $('.product_main_images_slider_nav').each(function(){
      var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
      if (current_color == data_handle ){
        $(this).show();
      }
    });
    $('.product_main_images_slider').each(function(){
      var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
      if (current_color == data_handle ){
        $(this).show();
      }
    });
    $('.product_main_images_slider').slick('refresh');
    $('.product_main_images_slider_nav').slick('refresh');
    // if ($(window).width() < 800) {
    // $('html, body').animate({
    //   scrollTop: $(".Product_images_mob").offset().top-50
    // }, 200);
    // }

    // STANDARD TEMPLATE =========== ORIGINAL TEMPLATE WILL BE ERROR FOR TEMPORARY
    // Filtering new variant gallery images
    $('.Product_images_standard_gallery_main').slick('slickUnfilter');
    $('.Product_images_standard_gallery_thumb').slick('slickUnfilter');
    console.log(data_handle, 'current color to be filtered');
    $('.Product_images_standard_gallery_main').slick('slickFilter', '.'+data_handle+'');
    $('.Product_images_standard_gallery_thumb').slick('slickFilter', '.'+data_handle+'');
  });

  // Product accordion functionality
  $('.Product_info_accordion_cell').click(function(){
      $(this).find('.inner').slideToggle();
      $(this).find('.accordion_img').toggle();
  });

  // Product carousel mobile gallery
  $('.product_main_images_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.product_main_images_slider_nav',
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowLeft.png?v=1681385120'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowRight.png?v=1681385120'/></button>"
  });
  $('.product_main_images_slider_nav').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.product_main_images_slider',
    focusOnSelect: true
  });

  function calculateButtonsStock(){
    // console.log('Calculating buttons stock');
    $('.product-form__input .Color_selector').each(function(){
      var currentClasses = $(this).attr('class'); // Get the current class list
      var color = currentClasses.replace('Color_selector', '').trim();
      // console.log(color);

      var colorTotalySoldout = 0;

      var fullVariantTitle = color;
      var SizeExists = 0;
      var currentInventory = 0;

      $('.Size_selector input[type=radio]+label').each(function(){
        SizeExists++;
        var currentSize = $(this).attr('class');
        currentSize = currentSize.replace('product_variant_option__', '');
        
        fullVariantTitle = color;
        fullVariantTitle = fullVariantTitle + '-' + currentSize;
        currentInventory = 0;
  
        $('.Product_form_variant_checker__js').each(function(){
          if ($(this).attr('data-handle') == fullVariantTitle){
            currentInventory = parseFloat($(this).attr('data-inv'));
          }
        });

        // console.log(fullVariantTitle, currentInventory, 'currentsize');

        if (currentInventory > 0){
          colorTotalySoldout++;
        }
      });

      if (SizeExists == 0){
        $('.Product_form_variant_checker__js').each(function(){
          if ($(this).attr('data-handle') == fullVariantTitle){
            currentInventory = parseFloat($(this).attr('data-inv'));
          }
        });

        if (currentInventory > 0){
          colorTotalySoldout++;
        }
      }
      // console.log(colorTotalySoldout, color);

      if (colorTotalySoldout == 0){
        $(this).addClass('totalySoldOut');
      }
    });

    // Select the parent container
    var colorSelector = $('.product-form__input.Color_selector');

    // Find all labels with the class "totalySoldOut"
    var soldOutItems = colorSelector.find('label.totalySoldOut');

    // Loop through each sold-out label
    soldOutItems.each(function() {
        var label = $(this); // Get the current label
        var input = label.prev('input'); // Get the input that comes before this label

        // Append the input and label to the end of the fieldset
        input.appendTo(colorSelector);
        label.appendTo(colorSelector);
    });
    
  }

  function calculateSizeStock(){

    $('.Size_selector input[type=radio]+label').removeClass('sizeSoldout');
    $('.Size_selector input[type=radio]+label').each(function(){
      var currentSize = $(this).attr('class');
      currentSize = currentSize.replace('product_variant_option__', '').replace(' ', '');

      // console.log(currentSize, 'SIZE OPTION');

      var color = $('.product-form__input input[type=radio]:checked+label.Color_selector').attr('class');
      color = color.replace('Color_selector', '');

      console.log('selected color', color);

      var fullTitle = '';
      fullTitle = color + '-' + currentSize;
      var currentInventory = 0;

      fullTitle = fullTitle.replace(' ','');
      console.log(fullTitle);
      $('.Product_form_variant_checker__js').each(function(){
        if (fullTitle == $(this).attr('data-handle') ){
          console.log('MATCH', fullTitle);
          currentInventory = parseFloat($(this).attr('data-inv'));
        }
      });

      // console.log(currentInventory, currentSize);
      if (currentInventory < 1){
        $(this).addClass('sizeSoldout');
      }

    });
  }

  calculateButtonsStock();
  calculateSizeStock();

  $('.product-variant-id').change(function(){
    calculateSizeStock();
    var currentId = $(this).attr('value');
    var currentInventory = 0;
    $('.Product_form_variant_checker__js').each(function(){
      if ($(this).attr('data-id') == currentId){
        currentInventory = parseFloat($(this).attr('data-inv'));
      }
    });

     // Stock messages
    $('.Instock_message_line').hide();
    $('.Instock_message_line').each(function(){
      if ($(this).attr('data-id') == currentId){
        $(this).css('display', 'flex');
      }
    });
 
    // Badges
    if (
      currentId == '49597435904341' ||
      currentId == '49597435937109' ||
      currentId == '49597435969877' ||
      currentId == '49597436002645' ||
      currentId == '49597436035413' ||
      currentId == '49597436068181'
    ){
      $('.ssi_badge.bis_badge').show();
    }    
    else{
      $('.ssi_badge.bis_badge').hide();
    }
    
    console.log(currentInventory, 'STOCK');
    if (currentInventory < 1){
      $('.product-form .Product_atc_button').text('Razprodano');
      $('.product-form .Product_atc_button').attr('data-stock', '0')
    }
    if (currentInventory > 0){
      $('.product-form .Product_atc_button').text('Dodaj v košarico');
      $('.product-form .Product_atc_button').attr('data-stock', '1')
    }


    // Settuping back to stock signup form
        $('.stockSignup_klaviyo_form_outer').hide();
        $('.stockSignup_klaviyo_form_outer').each(function(){
          if ($(this).attr('data-id') == currentId){
            $(this).show();
          }
        });
    
        if (currentInventory < 1){
          $('.stockSignUpForm_outer').show();
          if ($(window).width() < 800) {
            $('html, body').animate({
              scrollTop: $(".stockSignUpForm_outer").offset().top-200
            }, 500);
          }
        }
        else{
          $('.stockSignUpForm_outer').hide();
        }
  });

// Product section, size chart popup
  $('.Product_variant_size_chart').click(function(){
    $('.Product_popup_whole').css('display', 'flex');
  });

  $('.Product_popup_inner_close').click(function(){
    $('.Product_popup_whole').hide();
  });

// Features Switch
$('.Product_features_nav_bubble').click(function(){
  var data = $(this).attr('data');
  $('.Product_features_image__js').hide();
  $('.Product_features_image__js').each(function(){
    if ($(this).attr('data') == data){
      $(this).show();
    }
  });
});

// Faq
$('.Faq_accordion_cell').click(function(){
  $(this).toggleClass('active');
  $(this).find('.Faq_accordion_content').slideToggle();
});

// Scroll animation

$('.scroll_to_js').click(function(){
  $('html, body').animate({
    scrollTop: $(".Product_section_main").offset().top-100
}, 200);
});

// Carousel slick
$('.Product_page_gallery_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: false,
  });

  $('.Product_gallery_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: false,
  });

// Hero banner cta functionality
  $('.Product_hero_cta_box').click(function(){
    $('html, body').animate({
      scrollTop: $(".Product_section_main").offset().top
  }, 200);
  });

  // Sticky header
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 300) {
        // Customer has scrolled below 400 pixels from the top
        // $('.Product_header_outer.Bottom').css('bottom', '0');
        // Add your desired code or actions here
    }
    else{
      // $('.Product_header_outer.Bottom').css('bottom', '-300px');
    }
  });

  setTimeout(function(){
    $('input.First_variant_trigger').trigger('click');
    console.log('CLicked');
  },1600);

  // Ugc play video
  $('.Product_ugc_play_button').click(function(){
    $(this).hide();
    $(this).parent('div').find('.Product_ugc_pause_button').show();
    console.log('Play');
    var video = $(this).parent('div').find('video')[0];
    if (video) {
        video.play();
    }
  });
  $('.Product_ugc_pause_button').click(function(){
    $(this).hide();
    $(this).parent('div').find('.Product_ugc_play_button').show();
    console.log('Pause');
    var video = $(this).parent('div').find('video')[0];
    if (video) {
      video.pause(); 
      video.currentTime = 0;
    }
  });

  $('.Mobile_ProductS_ugc_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: false,
  });

  $(".Quiz_hero_carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Icon_ionic-ios-arrow-round-forward-1.png?v=1700571436'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Icon_ionic-ios-arrow-round-forward.png?v=1700571437'/></button>",
  });

  $('.Quiz_offer_button').click(function(evt){
    evt.preventDefault();
    $('html, body').animate({
        scrollTop: $(".Product_section_main").offset().top
    }, 200);
  });

  // Standard product page details

  $(document).on('click','.Product_price_badge_standard',function(){
    // console.log('Click');
    $('.Product_price_info_note').toggle();
    setTimeout(function(){
      $('.Product_price_info_note').toggleClass('active');
    },100);
  });

  $('.Product_section_main').click(function (e) {
    // Check if the clicked element or any of its ancestors have the class .Product_price_badge_standard
    if ($(e.target).closest('.Product_price_badge_standard').length === 0) {
        // Clicked outside .Product_price_badge_standard, hide .Product_price_info_note
        $('.Product_price_info_note').removeClass('active');
        setTimeout(function () {
            $('.Product_price_info_note').hide();
        }, 100);
    }
  });


  $('.Product_images_standard_gallery_main').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Group_2524.png?v=1686900777'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Group_2523.png?v=1686900776'/></button>",
    asNavFor: '.Product_images_standard_gallery_thumb',
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          dots: true,
          arrows: false
        }
      }
    ]
  });

  $('.Product_images_standard_gallery_thumb').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.Product_images_standard_gallery_main',
    focusOnSelect: false
  });

  // Gallery popup
  $('.Product_images_gallery_zoomin').click(function(){
    var dataSrc = $(this).attr('data-src');
    $('.Product_images_popup_overlay img').attr('src', dataSrc);
    $('.Product_images_popup_overlay').css('display', 'flex');
    setTimeout(function(){
      $('.Product_images_popup_overlay').css('opacity', '1');
    },500);
  });

  $('.Product_images_popup_overlay').click(function(){
    $('.Product_images_popup_overlay').css('opacity', '0');
    setTimeout(function(){
      $('.Product_images_popup_overlay').hide();
    },300);
  });


  $('.Product_images_standard_gallery_thumb .slick-slide').click(function(){
      var currentIndex = $(this).attr('data-slick-index');
      var activeIndex = $('.Product_images_standard_gallery_thumb .slick-slide.slick-current').attr('data-slick-index');
      var currentDiffer = parseFloat(currentIndex) - parseFloat(activeIndex);
      // console.log(currentDiffer, 'INDEXES ======  ');
      var stopCounting = false;
      var index = 0;
      $('.Product_images_standard_gallery_thumb .slick-slide').each(function () {
        if (stopCounting) {
            return false; 
        }
        index++;
        if ($(this).hasClass('slick-current')) {
            stopCounting = true;
        }
    });
      index = index + currentDiffer -1;
      console.log(index, 'INDEX current');

      $('.Product_images_standard_gallery_main').slick('slickGoTo', index);
  });

  
  $('.det_inn').click(function(){
    $('.det_inn').removeClass('active');
    $(this).addClass('active');
    var data = parseFloat($(this).attr('data'));
    $('.quantity__input').attr('value', data);
    $('.quantity__input').val(data);
  });

  $('.detu_expand_upsell').click(function(){
    var data = $(this).attr('data');
    if (data == '1'){
      $(this).attr('data', '0');
      $(this).html('Pokaži manj');
    }
    else{
      $(this).attr('data', '1');
      $(this).html('O izdelku');
    }
    $('.detu_expandable').slideToggle();
  });

  $('.detu_qty_plus').click(function(){
    var value = parseFloat($('.detu_qty_val').html());
    value++;
    $('.detu_qty_val').html(value);
  });

  $('.detu_qty_min').click(function(){
    var value = parseFloat($('.detu_qty_val').html());
    if (value > 1){
      value--;
    }
    
    $('.detu_qty_val').html(value);
  });

  $('.nlu_pillow_select__js').change(function(){
    var pillow_id = $(this).val();
    var pillow_title = $('.nlu_piilow_checker[data-id="'+pillow_id+'"]').attr('data-title');
    console.log(pillow_title );
    $('.pillow_img').hide();
    if (pillow_title.indexOf('bela') != -1){
      $('.pillow_img[data="balta"]').show();
    }

    else if (pillow_title.indexOf('biserno bela') != -1){
      $('.pillow_img[data="perlu-balta"]').show();
    }
    else if (pillow_title.indexOf('sivkasta') != -1){
      $('.pillow_img[data="levanda"]').show();
    }
    else if (pillow_title.indexOf('svetlo-modra') != -1){
      $('.pillow_img[data="sviesiai-melyna"]').show();
    }
    else if (pillow_title.indexOf('temno-siva') != -1){
      $('.pillow_img[data="tamsiai-pilka"]').show();
    }
      
    else if (pillow_title.indexOf('siva') != -1){
      $('.pillow_img[data="pilka"]').show();
    }
    else if (pillow_title.indexOf('crna') != -1){
      $('.pillow_img[data="juoda"]').show();
    }
    else if (pillow_title.indexOf('ruda') != -1){
      $('.pillow_img[data="ruda"]').show();
    }
    else if (pillow_title.indexOf('zelena') != -1){
      $('.pillow_img[data="zalia"]').show();
    }
    else if (pillow_title.indexOf('temno-modra') != -1){
      $('.pillow_img[data="tamsiai-melyna"]').show();
    }
    else if (pillow_title.indexOf('modra') != -1){
      $('.pillow_img[data="melyna"]').show();
    }
    else if (pillow_title.indexOf('bela') != -1){
      $('.pillow_img[data="balta"]').show();
    }
    else if (pillow_title.indexOf('roza-zlata') != -1){
      $('.pillow_img[data="pelenu"]').show();
    }
    else if (pillow_title.indexOf('roza') != -1){
      $('.pillow_img[data="rozine"]').show();
    }
    else if (pillow_title.indexOf('rdeca') != -1){
      $('.pillow_img[data="raudona"]').show();
    }
    else if (pillow_title.indexOf('rjava') != -1){
      $('.pillow_img[data="ruda"]').show();
    }
    else if (pillow_title.indexOf('sampanjec') != -1){
      $('.pillow_img[data="sampanine"]').show();
    }
    else if (pillow_title.indexOf('kremna') != -1){
      $('.pillow_img[data="kremine"]').show();
    }
  });


  $('.nlu_eukalipt_change').change(function(){

    $('.nlu_eukalipt_change').each(function(){
      var value = $(this).val();
        if (value == '150x200'){
          $('.nlu_eukalipt_change').each(function(){
            var optionValue = $(this).val();
            if (
               String(optionValue).indexOf('160x200') != -1
            || String(optionValue).indexOf('180x200') != -1
            || String(optionValue).indexOf('240x260') != -1){
              $(this).val('90x200');
              $(this).find('option').hide();
              $(this).find('option[value="90x200"]').show();
            }
          });
        }
        else if (value == '200x200' || value == '200x220'){
          $('.nlu_eukalipt_change').find('option').show();
          $('.nlu_eukalipt_change').find('option[value="90x200"]').hide();
          $('.nlu_eukalipt_change').each(function(){
            var optionValue = $(this).val();
            if (
               String(optionValue).indexOf('90x200') != -1){
              $(this).val('160x200');
            }
          });
        }
      });
  
    var fullTitle = '';
    $('.nlu_eukalipt_change').each(function(){
      var thisVal = $(this).val();
      fullTitle = fullTitle + '-' + thisVal;
    });
    fullTitle = fullTitle.substring(1);

    $('.nlu_pa_price').hide();
    $('.nlu_pa_price').removeClass('active');
    $('.nlu_pa_price').each(function(){
      if ($(this).attr('data-title') == fullTitle){
        $(this).show();
        $(this).addClass('active');
      }
    });

    console.log(fullTitle);
    $('.eukalipt_img').hide();
    if (fullTitle.indexOf('kremna') != -1){
      $('.eukalipt_img[data="kremine"]').show();
    }
    else if(fullTitle.indexOf('siva') != -1){
      $('.eukalipt_img[data="pilka"]').show();
    }
    else if(fullTitle.indexOf('bela') != -1){
      $('.eukalipt_img[data="balta"]').show();
    }
  });


  // Timer
   // // Target date and time (November 23, 2023)
   // var targetDate = new Date("2023-11-29T00:00:00").getTime();

   // var timer = setInterval(function () {
   //     var currentDate = new Date().getTime();
   //     var timeLeft = targetDate - currentDate;

   //     if (timeLeft <= 0) {
   //         clearInterval(timer);
   //         $('.Product_header_timer_inner').html('Countdown expired');
   //     } else {
   //         var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
   //         var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
   //         var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
   //         var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

   //         $('.Product_header_timer_days .timing').text(days);
   //         $('.Product_header_timer_hours .timing').text(hours);
   //         $('.Product_header_timer_minutes .timing').text(minutes);
   //         $('.Product_header_timer_seconds .timing').text(seconds);
   //     }
   // }, 1000); // Update every 1 second

  
  $('.pke_option_grid_block').click(function(){
    $(this).closest('.pke_option_grid').find('.pke_option_grid_block').removeClass('active');
    $(this).addClass('active');
    
    var color = '.'+$('.pke_color_box.active').attr('data-title');
  
    $('.pke_main_gallery').slick('slickUnfilter');
    $('.pke_main_gallery').slick('slickFilter', color);
  
    var varTitle = '';
    $(this).closest('.pke_outer').find('.pke_option_grid_block.active').each(function(){
      var currentTitle = $(this).attr('data-title');
      varTitle = varTitle + '-' + currentTitle;
    });
  
    varTitle = varTitle.substring(1);
  
    var currentId = $('.pke_eu_variant_checker[data-title="'+varTitle+'"]').attr('data-id');
    var currentInv = $('.pke_eu_variant_checker[data-title="'+varTitle+'"]').attr('data-inv');
  
    if (currentInv == '0'){
      $('.pke_atc_btn').html('Razprodano');
    }
    else{
      $('.pke_atc_btn').html('Dodaj v košarico');
    }
    $(this).closest('.pke_outer').find('.pke_price_line').hide();
    $(this).closest('.pke_outer').find('.pke_price_line[data-id="'+currentId+'"]').css('display', 'flex');
  
    $(this).closest('.pke_outer').find('.pke_atc_btn').attr('data-id', currentId);
    console.log(currentId);
  
  
  });

   $('.pke_main_gallery').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowLeft.png?v=1681385120'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowRight.png?v=1681385120'/></button>"
  });
  
});